import moment from "moment";
import { toWords } from "number-to-words";

const SCHOOL_SESSION_END = process.env.SCHOOL_SESSION_END || "04-01"; // MM-DD format

export const TOKEN_EXPIRY_TIME_IN_MINUTES = 300; // 300 MIN (5 Hr.)
export const PRODUCT_VERSION = "1.2.6";
export const DEFAULT_LOGGED_USER = "ankuramvp";

export const romanToClass = {
  LKG: "LKG",
  UKG: "UKG",
  I: "1st",
  II: "2nd",
  III: "3rd",
  IV: "4th",
  V: "5th",
  VI: "6th",
  VII: "7th",
  VIII: "8th",
  IX: "9th",
  X: "10th",
  XI: "11th",
  XII: "12th",
};

export const MAIN_CLASS_ORDER = [
  "NURSERY",
  "LKG",
  "UKG",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "XI",
  "XII",
];

export const SUBJECT_ORDER_NUR_UKG = [
  "HINDI",
  "HINDI ORALS",
  "MATHS",
  "MATHS ORAL",
  "ENGLISH",
  "ENGLISH ORAL",
];

export const SUBJECT_ORDER_I_X = [
  "HINDI",
  "ENGLISH",
  "MATHS",
  "SCIENCE",
  "SST",
  "COMPUTER",
];

export const ADMIT_CARD_EXCLUSION_EXAM = [];

export const PERIODIC01 = "PT-1";
export const PERIODIC02 = "PT-2";
export const PERIODIC03 = "PT-3";
export const PERIODIC04 = "PT-4";
export const HALF_YEARLY = "SA-1";
export const ANNUAL = "SA-2";

export const EXAMS_WITH_REPORTCARD = [
  // PERIODIC01,
  // PERIODIC02,
  // PERIODIC03,
  // PERIODIC04,
  HALF_YEARLY,
  ANNUAL,
];

export const TERM1_EXAMS = [PERIODIC01, PERIODIC02, HALF_YEARLY];
export const TERM2_EXAMS = [PERIODIC03, PERIODIC04, ANNUAL];

export const EXAM_NAME_ALIAS = {
  "PT-1": "PT-1",
  "PT-2": "PT-2",
  "PT-3": "PT-3",
  "PT-4": "PT-4",
  "SA-1": "HALF YEARLY",
  "SA-2": "ANNUAL",
};

export const SHORT_SUBJECTS = [];

export const CreatePerformaceObj = (examsList, exam_schedules) => {
  try {
    const performance = {};

    // Iterate over each exam
    examsList.forEach((exam) => {
      const {
        session,
        exam_id,
        name,
        code,
        // max_marks, //Commented. Should be coming from Schedule itself
        // pass_marks, //Commented Not need now. But Should be coming from Schedule itself
        // total_working_days, //Commented Not need now. Should only be the part of base template
      } = exam;

      // Initialize the session if not present
      //@ts-ignore
      if (!performance[session]) {
        //@ts-ignore
        performance[session] = { exams: {} };
      }

      // Find the corresponding exam schedule
      const schedule = exam_schedules.find(
        (sched) => sched.exam_id === exam_id
      );

      // Extract subjects from the schedule
      let marks_details = [];
      let totalMarks = 0;
      let totalPassMarks = 0;

      if (schedule) {
        const subjects = JSON.parse(schedule.exam_schedule);
        marks_details = subjects.map((subject) => {
          console.log("Subject Name: ", subject.subject);
          const max_marks = parseInt(subject.max_marks, 10);

          totalMarks += Number(max_marks);
          // totalPassMarks += Number(_pass_marks);

          return {
            subject_name: subject.subject.toUpperCase(),
            marks_obtained: null, // Default value
            subject_max_marks: Number(max_marks),
            subject_pass_marks: null, //THIS ATTRIBUTE IS NOT NEEDED AS OF NOW. ONLY PLACEHOLDER IF NEEDED IN FUTURE
            // subject_pass_marks: Number(_pass_marks),
          };
        });
      }

      // Populate exam details
      //@ts-ignore
      performance[session].exams[exam_id] = {
        exam_name: name,
        exam_code: code,
        max_marks: totalMarks,
        pass_marks: totalPassMarks,
        total_marks_obtained: null, // Default value. TO BE POPULATED WHILE UPDATING MARKS FOR REPORT CARD
        total_working_days: null, // Default value. TO BE POPULATED WHILE UPDATING MARKS FOR REPORT CARD
        // total_working_days: total_working_days,
        total_days_present: null, // Default value. TO BE POPULATED WHILE UPDATING MARKS FOR REPORT CARD
        marks_details,
      };
    });

    return performance;
  } catch (error) {
    console.log("Error getting Performance object");
    console.log(error);
    return {};
  }
};

export const getGrade = (total, base = 100) => {
  const percent = (total / base) * 100;

  if (percent >= 91) return "A1";
  if (percent >= 81) return "A2";
  if (percent >= 71) return "B1";
  if (percent >= 61) return "B2";
  if (percent >= 51) return "C1";
  if (percent >= 41) return "C2";
  if (percent >= 33) return "D";
  return "E";
};

export const getTermTotal = (marks, term) => {
  if (marks) {
    const fields = term === 1 ? TERM1_EXAMS : TERM2_EXAMS;
    return fields.reduce((sum, key) => sum + Number(marks[key] || 0), 0);
  } else {
    return null;
  }
};

export const GetCurrentAcademciSession = () => {
  const currentYear = moment().year();
  const sessionEndDate = moment(
    `${currentYear}-${SCHOOL_SESSION_END}`,
    "YYYY-MM-DD"
  );
  const today = moment();

  if (today.isBefore(sessionEndDate)) {
    return `${currentYear - 1}-${currentYear}`;
  } else {
    return `${currentYear}-${currentYear + 1}`;
  }
};

export const getAcademicYearsList = () => {
  const currentSession = GetCurrentAcademciSession(); // Uses the function we defined earlier
  const [startYear, endYear] = currentSession.split("-").map(Number);

  return [
    // `${startYear - 1}-${endYear - 1}`, // Past academic year
    `${startYear}-${endYear}`, // Current academic year
    // `${startYear + 1}-${endYear + 1}`, // Next academic year
  ];
};

export const getPastAcademicYearsList = () => {
  const currentSession = GetCurrentAcademciSession(); // Uses the function we defined earlier
  const [startYear, endYear] = currentSession.split("-").map(Number);

  // return [`${startYear}-${endYear}`, `${startYear - 1}-${endYear - 1}`];

  return [`${startYear}-${endYear}`];
};

export const dateToWords = (dateStr) => {
  const date = moment(dateStr, "DD-MM-YYYY");
  if (!date.isValid()) return "";

  const day = toWords(date.date()).toUpperCase(); // 25 -> TWENTY FIVE
  const month = date.format("MMMM").toUpperCase(); // May -> MAY
  const yearWords = date.year().toString().split("").map(Number);

  const yearNumber = date.year();
  const yearInWords = toWords(yearNumber).toUpperCase(); // 2008 -> TWO THOUSAND EIGHT

  return `${day} ${month} ${yearInWords.replace(",", "")}`;
};

export const extractClassLevel = (str) => {
  const romanToClass = {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5,
    VI: 6,
    VII: 7,
    VIII: 8,
    IX: 9,
    X: 10,
    XI: 11,
    XII: 12,
  };

  const match = str.match(/^(I{1,3}|IV|V?I{0,3}|IX|X|XI{0,2}|XII)/); // Match Roman at start
  if (match) {
    const roman = match[0];
    const classNum = romanToClass[roman];
    if (classNum === 10) return "10th";
    if (classNum === 12) return "12th";
  }

  return null; // If not matched
};

export const generateSecurePassword = (length = 8) => {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const digits = "0123456789";
  const special = "!@#$%^&*_=+?";
  const all = upper + lower + digits + special;

  const getRandom = (str) => str[Math.floor(Math.random() * str.length)];

  let password = [
    getRandom(upper),
    getRandom(lower),
    getRandom(digits),
    getRandom(special),
  ];

  while (password.length < length) {
    password.push(getRandom(all));
  }

  return password.sort(() => 0.5 - Math.random()).join("");
};

export function sortClassData(data) {
  const sortedEntries = Object.entries(data).sort(([a], [b]) => {
    const indexA = MAIN_CLASS_ORDER.findIndex((cls) => a === cls);
    const indexB = MAIN_CLASS_ORDER.findIndex((cls) => b === cls);

    // Put unknowns like "dummy" at the end
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  return Object.fromEntries(sortedEntries);
}

export const getFilteredSection = (classId, sectionList) => {
  const isSpecialClass = ["14", "16"].includes(classId);
  const filterIds = isSpecialClass ? ["10", "2"] : ["10"];

  const _filteredSectionIds = sectionList.filter((sec) =>
    isSpecialClass
      ? filterIds.includes(sec.section_id)
      : !filterIds.includes(sec.section_id)
  );

  return _filteredSectionIds;
};

export function showUpdatingStatus(snackbarRef) {
  snackbarRef?.current?.showSnackbar(
    "Updating Manage Subjects feature. Will be available soon.",
    "info"
  );
}

export const flattenObject = (obj, prefix = "") =>
  Object.keys(obj).reduce((acc, key) => {
    const value = obj[key];
    const fullKey = prefix ? `${prefix}.${key}` : key;

    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      Object.assign(acc, flattenObject(value, fullKey));
    } else {
      acc[fullKey] = value;
    }

    return acc;
  }, {});
